// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  id: __t.string(),
  playerId: __t.string().name("player_id"),
  ruleset: __t.string(),
  archetype: __t.string(),
  customName: __t.option(__t.string()).name("custom_name"),
  level: __t.u32(),
  experience: __t.u32(),
  troopsPercent: __t.f64().name("troops_percent"),
  kills: __t.u32(),
  battlesSurvived: __t.u32().name("battles_survived"),
  skillsJson: __t.string().name("skills_json"),
});
